(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blaspo-delivery-window"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blaspo-delivery-window')) {
  class BlaspoDeliveryWindow extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe('variant-change', ({data}) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          const source = data.html.querySelector('blaspo-delivery-window');
          if (source) this.replaceWith(source.cloneNode(true));
        });
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  }
  customElements.define('blaspo-delivery-window',BlaspoDeliveryWindow);
}
  } catch(e) { console.error(e); }
})();

})();
